import { Outlet, useLocation } from 'react-router-dom';
import { Navigation } from '~/components/common';
import { Header } from '~/components/common/Header';
import { PAGE_ROUTE } from '~/constants';

export default function LayoutMyPage() {
  const { pathname } = useLocation();

  const getTitle = (location: string) => {
    switch (location) {
      case PAGE_ROUTE.REPORT:
        return 'Report';
      case PAGE_ROUTE.SETTINGS:
        return 'Settings';
      case PAGE_ROUTE.ACCOUNT:
        return 'Account';
      case PAGE_ROUTE.CHANGE_PASSWORD:
        return 'Change password';
      case PAGE_ROUTE.MORE_ONE_ON_ONE:
        return 'Chat';
      case PAGE_ROUTE.SUBSCRIPTION:
        return '';
      default:
        return '';
    }
  };
  const title = getTitle(pathname);

  return (
    <>
      <Header.Root>
        <Header.Section>
          <Header.PrevButton />
          <Header.Title>{title}</Header.Title>
        </Header.Section>
      </Header.Root>

      <Outlet />
      {(pathname === PAGE_ROUTE.MORE_ONE_ON_ONE ||
        pathname === PAGE_ROUTE.SUBSCRIPTION) && <Navigation />}
    </>
  );
}
